import { customReportUrl } from 'urls'
import axios from 'axios'
import { getAxiosDefaultConfig } from 'utils'
import _ from 'lodash'

export function setCustomReportId(id) {
  return {
    type: 'SET_REPORT_ID_CUSTOM_REPORTS',
    payload: id,
  }
}

export function setCustomReports(reports) {
  return {
    type: 'SET_REPORTS_CUSTOM_REPORTS',
    payload: reports,
  }
}

export function setCustomReportSortOrder(sortOrder) {
  return {
    type: 'SET_SORT_ORDER_CUSTOM_REPORTS',
    payload: sortOrder,
  }
}

export function setCustomReportsStatus(status) {
  return {
    type: 'SET_REPORT_STATUS_CUSTOM_REPORTS',
    payload: status,
  }
}

export const getCustomReports = (callback) => {
  return async (dispatch) => {
    dispatch({ type: 'SET_REPORT_STATUS_CUSTOM_REPORTS', payload: 'loading' })
    try {
      const { data: customReports } = await axios.get(customReportUrl, getAxiosDefaultConfig())
      dispatch(setCustomReports(customReports))
      dispatch({ type: 'SET_REPORT_STATUS_CUSTOM_REPORTS', payload: null })
      if (callback) {
        callback()
      }
    }
    catch(err) {
      const errMsg = _.get(err, ['response', 'data', 'errors'], 'Errors when fetching custom reports')
      console.error(errMsg)
      dispatch({ type: 'SET_REPORT_STATUS_CUSTOM_REPORTS', payload: null })
    }
  }
}

export const saveCustomReport = (config, saveSettingsOnly, skipListUpdate = false) => {
  return async (dispatch, getState) => {
    const {
      reportId,
      name,
      folderName,
      visibility,
      emailReportInterval,
      mailingList,
      googleDriveInterval = 'NEVER',
      saveFilePreference,
      dateRange,
      folderId,
      fileId,
      callback,
      selectedEmail,
      filters: filtersFromConfig,
      filter_configs: filterConfigsFromConfig,
    } = config
    dispatch({ type: 'SET_REPORT_STATUS_CUSTOM_REPORTS', payload: 'saving' })
    try {
      const { user: { dashboardconfig: dashboardConfig } } = getState().root
      const { rangeFilters, keywordFilters, } = getState()
      const { filters, filterLogicOperator, viewList, viewIndex, report } = getState().dashboard
      const { reports: customReports } = getState().customReports
      const { dateType } = getState().datePicker
      const reportView = viewList[viewIndex] || 'overview'
      const nextCustomReportConfig = {
        name,
        google_drive_folder_name: folderName,
        report_view: reportView,
        report,
        visibility,
        email_report_interval: emailReportInterval,
        google_drive_report_interval: googleDriveInterval,
        mailing_list: mailingList,
        owned: true,
        google_drive_file_overwrite: saveFilePreference,
        date_range: dateRange,
        update_time: (new Date()).toISOString(),
        google_drive_folder_id: folderId,
        google_drive_file_id: fileId,
        google_drive_email: selectedEmail,
        ...(saveSettingsOnly ? null : {
          dashboard_config: dashboardConfig,
          filters: filtersFromConfig || filters,
          filter_configs: {
            rangeFilters: filterConfigsFromConfig?.rangeFilters || rangeFilters,
            keywordFilters: filterConfigsFromConfig?.keywordFilters || keywordFilters,
            // conditionFilters: filterConfigsFromConfig?.conditionFilters || conditionFilters,
          },
          logic_operator: filterLogicOperator,
          keywords: filtersFromConfig?.keywords?.[0] || filters?.keywords?.[0] || '',
          date_type: dateType,
        })
      }
      const { data: { id: nextCustomReportId } }= await axios.request({
        method: reportId ? 'PUT' : 'POST',
        url: customReportUrl + (reportId ? `/${reportId}` : ''),
        data: nextCustomReportConfig,
        ...getAxiosDefaultConfig(),
      })

      if (!skipListUpdate) {
        const nextCustomReports = nextCustomReportId ? [
          ...customReports,
          {
          id: nextCustomReportId,
          ...nextCustomReportConfig,
        }
      ] : customReports.map(r => (r.id === reportId) ? {
        ...r,
            ...nextCustomReportConfig
          } : r)
        dispatch(setCustomReports(nextCustomReports))
      }
      if (nextCustomReportId) {
        dispatch(setCustomReportId(nextCustomReportId))
      }
      dispatch({ type: 'SET_REPORT_STATUS_CUSTOM_REPORTS', payload: 'success' })
      let message = googleDriveInterval !== 'NEVER' ? 'Report saved and scheduled for Google Drive'
        : emailReportInterval !== 'NEVER' ? 'Report saved and scheduled for Email' : 'Report saved'
      if (googleDriveInterval !== 'NEVER' && emailReportInterval !== 'NEVER') {
        message += ' and Email'
      }
      dispatch({ type: 'SET_SHIPPING_TOAST_MESSAGE', payload: message })
      dispatch({ type: 'SET_SHIPPING_TOAST_NOTIFICATION', payload: true })
      if (callback) {
        callback()
      }
    }
    catch(err) {
      console.error(err, 'Errors when saving custom report')
      dispatch({ type: 'SET_REPORT_STATUS_CUSTOM_REPORTS', payload: 'error' })
      dispatch({ type: 'SET_SHIPPING_TOAST_MESSAGE', payload: 'Error saving report custom report' })
      dispatch({ type: 'SET_SHIPPING_TOAST_NOTIFICATION', payload: true })
    }
  }
}

export const deleteCustomReport = (reportId, callback) => {
  return async (dispatch, getState) => {
    dispatch({ type: 'SET_REPORT_STATUS_CUSTOM_REPORTS', payload: 'loading' })
    try {
      const { reports: customReports } = getState().customReports
      await axios.delete(`${customReportUrl}/${reportId}`, getAxiosDefaultConfig())
      const nextCustomReports = customReports.filter(r => r.id !== reportId)
      dispatch(setCustomReports(nextCustomReports))
      dispatch(setCustomReportId(null))
      dispatch({ type: 'SET_REPORT_STATUS_CUSTOM_REPORTS', payload: null })
      if (callback) {
        callback()
      }
    }
    catch(err) {
      console.error(err, 'Errors when deleting custom report')
      dispatch({ type: 'SET_REPORT_STATUS_CUSTOM_REPORTS', payload: null })
    }
  }
}
